import { useCallback, useEffect, useState } from "react";
import style from "../../../sass/custom/table.module.scss";
import { adminApi } from "../../../api/admin/admin";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../alerts/alertSlice";
import UserRow from "./UserRow";
import GreenSpinner from "../../../components/loaders/GreenSpinner";

const UserTable = () => {
    const dispatch = useDispatch()
    const [users, setUsers] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const fetchUsers = useCallback(() => {
        (async function() {
            setIsLoading(true)
            const resp = await adminApi.getAllUsers()
            if(!resp.ok) {
                dispatch(pushAlert({
                    message: resp.err,
                    delay: 5000,
                }))
                setIsLoading(false)
                return;
            }

            setIsLoading(false)
            setUsers(resp.users)
        })()

    }, [dispatch])

    useEffect(() => {
        fetchUsers()
    }, [fetchUsers])

    const login = async (email) => {
      if(!email) return;

      const resp = await adminApi.loginAsUser(email);
      if(!resp.ok) {
        dispatch(pushAlert({
          message: resp.err,
          delay: 5000,
        }))
        return;
      };

      window.location.href = "/profile";
    }

  return (
    <div style={{maxWidth:"1366px"}} className="p-4">
        {isLoading && <div className="m-10"><GreenSpinner /></div>}
        <table className={style.table}>
            <thead>
                <tr>
                    <th>
                        <div className="inline-flex flex-col gap-0.5">
                            <span>ID</span>
                        </div>
                    </th>
                    <th>
                        <div className="inline-flex flex-col gap-0.5">
                            <span>Login</span>
                        </div>
                    </th>
                    <th>
                        <div className="inline-flex flex-col gap-0.5">
                            <span>Email</span>
                        </div>
                    </th>
                    <th>
                        <div className="inline-flex flex-col gap-0.5">
                            <span>User type</span>
                        </div>
                    </th>
                    <th>
                        <div className="inline-flex flex-col gap-0.5">
                            <span>Name / Company</span>
                        </div>
                    </th>
                    <th>
                        <div className="inline-flex flex-col gap-0.5">
                            <span>Discount in %</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                { users.map(user => <UserRow key={user.id} user={user} login={login} fetchUsers={fetchUsers} />)}
            </tbody>
        </table>
    </div>
  )
}

export default UserTable